import type { NovelTheme } from '../../components/ReaderSettings';

const DARK_THEMES: ReadonlySet<string> = new Set(['night', 'midnight']);

/**
 * Returns true when the given theme uses a dark color scheme.
 */
export function isDarkTheme(theme: NovelTheme | string): boolean {
  return DARK_THEMES.has(theme);
}
